import React from 'react';
import { Callout, Kbd, List, P, Steps, Sub, Table, UI } from '../ui';

export const Messaging: React.FC = () => (
  <>
    <Sub>메시지 보내기</Sub>
    <Table
      head={['조작', '동작']}
      rows={[
        [
          <>
            <Kbd>Enter</Kbd>
          </>,
          '메시지 전송',
        ],
        [
          <>
            <Kbd>Shift</Kbd> + <Kbd>Enter</Kbd>
          </>,
          '줄바꿈 (여러 줄 작성)',
        ],
        [
          <>
            <Kbd>Ctrl</Kbd> + <Kbd>V</Kbd>
          </>,
          '복사한 표는 표 모양 그대로, 이미지는 첨부로',
        ],
      ]}
    />
    <Callout tone="info" title="엑셀 표를 복사하면 표로 들어갑니다">
      <p>
        엑셀·구글 시트·워드에서 <b>셀을 복사해</b> 입력창에 붙여넣으면 사진이 아니라 <b>표</b>로
        들어갑니다. 한 열만 복사해도 표가 됩니다. 받는 사람이 글자를 검색할 수 있고, 말풍선을
        우클릭해 <UI>복사</UI>하면 다시 엑셀에 표 그대로 붙일 수 있습니다.
      </p>
      <p>
        웹 페이지처럼 <b>글과 표가 섞인 내용</b>을 복사하면 글은 글대로, 표는 표로 함께 들어갑니다.
        복사한 곳에 따라 표가 칸이 나뉘지 않은 글로 들어올 수 있는데, 이때도 내용은 빠짐없이 들어갑니다.
      </p>
      <p>
        <b>입력창 안에서 칸을 바로 고칠 수 있습니다.</b> 붙여넣은 자리에 격자가 생기고, 칸을 눌러
        값을 고친 뒤 보내면 됩니다. 표 위나 아래에 쓴 문구는 쓴 자리 그대로 전송됩니다. 표를 없애려면
        격자 오른쪽 위의 <UI>✕</UI>를 누르세요. 행이나 열을 더하거나 지우는 것은 엑셀에서 하세요.
      </p>
      <p>
        한 번에 <b>100행 30열</b>까지 넣을 수 있고 그보다 크면 앞부분만 들어갑니다. 셀 안에서 줄을
        나눈 내용은 한 줄로 합쳐지고, 병합된 칸은 첫 칸에만 값이 들어갑니다. 글자 색·굵기·수식 같은
        서식은 남지 않고 값만 옮겨집니다.
      </p>
      <p>표가 아니라 사진으로 보내고 싶다면 엑셀 화면을 캡처해서 붙여넣으세요.</p>
    </Callout>
    <Callout tone="info" title="휴대폰·태블릿에서는 Enter가 줄바꿈입니다">
      <p>
        터치 화면 기기에서는 키보드의 줄바꿈(Enter) 키가 <b>줄만 바꾸고 전송하지 않습니다</b>. 메시지는 입력창
        오른쪽의 종이비행기 버튼으로 보냅니다. PC에서는 위 표대로 <b>Enter = 전송</b>입니다.
      </p>
    </Callout>
    <P>
      입력창은 글이 길어지면 자동으로 높이가 늘어나고, 일정 높이를 넘으면 그 안에서 스크롤됩니다. 입력창 오른쪽의
      웃는 얼굴 버튼을 누르면 이모지를 골라 <b>커서가 있는 위치에</b> 넣을 수 있습니다.
    </P>
    <Callout tone="info" title="대화방을 옮기면 작성 중이던 내용은 사라집니다">
      <p>
        아직 보내지 않은 글, 첨부하려던 파일, 답장 대상은 다른 대화방으로 이동하는 순간 초기화됩니다. 긴 글은
        보내고 나서 이동하세요.
      </p>
    </Callout>
    <P>
      <b>http://</b> 나 <b>https://</b> 로 시작하는 주소를 적으면 자동으로 링크가 되어, 받는 사람이 클릭하면 새
      창에서 열립니다. 잠시 뒤에는 링크 아래에 <b>제목과 미리보기 사진</b>이 담긴 카드가 함께 표시되어, 눌러보지
      않아도 어떤 페이지인지 알 수 있습니다. 미리보기 사진은 회사 서버에 저장된 것을 보여주므로 외부 사이트에
      접속 기록이 남지 않습니다.
    </P>
    <Callout tone="info" title="미리보기가 안 보이는 링크도 있습니다">
      <p>
        미리보기 정보를 제공하지 않는 사이트, 로그인해야 볼 수 있는 페이지, 사내 시스템 주소는 카드가 뜨지 않고
        링크 글자만 남습니다. 링크 자체는 정상적으로 열리므로 그대로 사용하시면 됩니다. 한 메시지에 주소를 여러 개
        넣으면 <b>맨 처음 주소 하나만</b> 카드로 만들어집니다.
      </p>
    </Callout>

    <Sub>답장하기</Sub>
    <Steps>
      <>답장할 메시지 위에 마우스를 올리면 오른쪽에 작은 버튼들이 나타납니다.</>
      <>화살표 모양의 답장 버튼을 클릭합니다.</>
      <>
        입력창 위에 <UI>○○○님에게 답장</UI> 안내와 원문 미리보기가 붙습니다. 취소하려면 <UI>×</UI>를 누릅니다.
      </>
      <>내용을 쓰고 보내면 원문이 인용된 형태로 전송됩니다.</>
    </Steps>
    <Callout tone="info" title="휴대폰에서는 말풍선을 밀어서 답장할 수 있습니다">
      <p>
        카카오톡처럼 <b>상대 말풍선은 오른쪽으로, 내 말풍선은 왼쪽으로 살짝 밀면</b> 바로 답장 모드가 됩니다.
        길게 눌러 메뉴에서 <UI>답장</UI>을 골라도 됩니다.
      </p>
    </Callout>
    <P>
      받은 답장에서 <b>인용된 원문을 클릭하면 그 메시지 위치로 이동</b>하고 2초 동안 노랗게 강조됩니다. 원문이
      삭제된 경우에는 &ldquo;삭제된 메시지입니다&rdquo;로 표시됩니다.
    </P>

    <Sub>멘션(@)으로 호출하기</Sub>
    <P>
      그룹·1:1 외 대화방 입력창에서 <Kbd>@</Kbd> 를 입력하면 부를 수 있는 대상 목록이 열립니다. 이름을 이어서
      입력하면 목록이 좁혀지고, 위아래 화살표와 <Kbd>Enter</Kbd>(또는 클릭)로 선택합니다.
    </P>
    <Table
      head={['대상', '누구에게 알림이 가나요']}
      rows={[
        ['@사람 이름', '그 사람에게만'],
        ['@부서 이름', '그 부서 소속이면서 이 대화방에 있는 사람들'],
        ['@all', '대화방 참여자 전원 (관리자·방장만 사용 가능)'],
      ]}
    />
    <List>
      <>
        멘션된 부분은 말풍선에서 파란 칩으로, <b>내가 멘션된 경우에는 노란 배경</b>으로 표시됩니다.
      </>
      <>
        <b>멘션은 알림 끄기(음소거)를 뚫습니다.</b> 대화방을 음소거해 두었어도 나를 콕 집어 부르면 알림이
        옵니다.
      </>
      <>대화방 멤버가 아닌 사람을 멘션하면 이름은 표시되지만 알림은 가지 않습니다 (선택 시 안내가 뜹니다).</>
    </List>

    <Sub>예약 전송</Sub>
    <P>
      메시지를 <b>지정한 시각에 자동으로 보낼 수 있습니다.</b> 퇴근 후에 떠오른 내용을 다음 날 아침에
      보내고 싶을 때 유용합니다.
    </P>
    <Steps>
      <>
        입력창 왼쪽 클립 모양 <UI>첨부</UI> 버튼을 눌러 <UI>예약 전송</UI>을 고릅니다. 입력창에 글을 쓰고 있었다면 PC에서는{' '}
        <b>전송 버튼을 우클릭</b>, 휴대폰에서는 <b>전송 버튼을 길게 눌러</b>도 됩니다.
      </>
      <>
        <UI>메시지 예약</UI> 창에서 <UI>보낼 메시지</UI>를 쓰고, 필요하면 사진·파일 버튼으로 첨부합니다.
        입력창에 써 두었던 글과 첨부는 이 창으로 그대로 옮겨 옵니다.
      </>
      <>
        <UI>보낼 시각</UI>을 고르고 <UI>예약</UI>을 누릅니다. 1분 뒤부터 30일 안까지 선택할 수 있습니다. 창은
        닫히지 않고 바로 아래 <UI>예약 목록</UI>에 방금 예약한 메시지가 나타납니다.
      </>
    </Steps>
    <P>
      예약이 잡히면 입력창 위에 <UI>예약 메시지 N건</UI> 칩이 나타납니다. 칩을 누르면 같은 창이 열리고, 목록에서
      각 예약을 <b>수정</b>(내용·첨부·시각)하거나 <b>취소</b>할 수 있습니다. 예약과 취소·수정은 내 다른
      기기(PC·휴대폰)에도 즉시 반영됩니다.
    </P>
    <List>
      <>한 번만 보내는 예약입니다 (매주 반복 예약은 지원하지 않습니다).</>
      <>
        사진·파일은 일반 메시지와 같은 한도로 첨부할 수 있습니다. 첨부한 파일의 보관 기간은 예약한 날이 아니라{' '}
        <b>실제로 보낸 날부터</b> 셉니다.
      </>
      <>수정할 때 새 멘션(@)을 추가할 수는 없습니다. 멘션을 바꾸려면 취소 후 다시 예약해 주세요.</>
      <>한 번에 20건까지 예약할 수 있습니다.</>
    </List>
    <Callout tone="info" title="예약 시각에 보낼 수 없으면 알려드립니다">
      <p>
        예약해 둔 대화방에서 나갔거나 대화방이 삭제된 경우, 첨부한 파일을 찾을 수 없는 경우에는 메시지가
        전송되지 않고, 예약 목록에 <b>보내지 못한 사유</b>가 표시됩니다. 앱을 켜 두었다면 알림 메시지도 뜹니다.
      </p>
    </Callout>

    <Sub>메시지 전달하기</Sub>
    <Steps>
      <>
        전달할 메시지를 우클릭해 <UI>전달</UI>을 누릅니다 (모바일은 길게 눌러 <UI>전달</UI>).
      </>
      <>대상 대화방을 고르는 창이 열립니다. 여러 방을 한 번에 선택할 수 있습니다 (최대 10개).</>
      <>
        <UI>전달</UI>을 누르면 내가 보낸 메시지로 각 방에 전송되고, 말풍선 위에{' '}
        <UI>전달됨 · 원래 보낸 사람</UI> 표시가 붙습니다.
      </>
    </Steps>
    <P>
      여러 메시지를 묶어 보내려면 창 아래의 <UI>여러 개 선택</UI>(또는 우클릭·길게 누르기 →{' '}
      <UI>선택하여 전달</UI>)로 <b>선택 모드</b>에 들어가, 말풍선을 탭해 체크한 뒤 (최대 20개) 아래{' '}
      <UI>전달</UI> 버튼을 누릅니다. <Kbd>Esc</Kbd> 또는 <UI>취소</UI>로 빠져나옵니다.
    </P>
    <List>
      <>사진·파일이 첨부된 메시지도 그대로 전달됩니다.</>
      <>삭제된 메시지와 시스템 안내문은 전달할 수 없습니다.</>
      <>공지 채널로는 관리자만 전달할 수 있습니다.</>
    </List>

    <Sub>메시지 수정</Sub>
    <P>
      <b>내가 보낸 글 메시지</b>는 보낸 뒤에도 고칠 수 있습니다. 메시지를 우클릭해 <UI>수정</UI>을 누르면
      (모바일은 길게 눌러 <UI>수정</UI>) 입력창에 원래 내용이 올라오고, 고쳐서 보내면 바뀝니다. <Kbd>Esc</Kbd>{' '}
      또는 <UI>×</UI>로 취소합니다.
    </P>
    <List>
      <>수정된 메시지에는 시각 옆에 <UI>(수정됨)</UI> 표시가 붙고, 상대 화면에도 즉시 반영됩니다.</>
      <>파일이나 사진이 첨부된 메시지는 수정할 수 없습니다.</>
    </List>

    <Sub>메시지 삭제</Sub>
    <P>
      메시지를 우클릭해 <UI>삭제</UI>를 누릅니다 (모바일은 길게 눌러 <UI>삭제</UI>). <b>내가 보낸 메시지만</b>{' '}
      삭제할 수 있습니다. 확인 창에서 한 번 더 눌러야 지워집니다.
    </P>
    <P>
      삭제해도 말풍선이 사라지지는 않고 회색 기울임체 <UI>(삭제된 메시지입니다)</UI>로 바뀝니다. 상대 화면에도
      즉시 반영됩니다.
    </P>

    <Sub>공지로 등록하기</Sub>
    <Steps>
      <>
        공지로 띄울 메시지를 우클릭해 <UI>공지로 등록</UI>을 누릅니다 (모바일은 길게 눌러 <UI>공지로 등록</UI>).
      </>
      <>대화방 위쪽에 노란 공지 띠가 생기고, 방에 있는 모두에게 똑같이 표시됩니다.</>
      <>공지 띠를 클릭하면 그 메시지가 있던 위치로 바로 이동합니다.</>
      <>
        오른쪽 화살표로 펼치면 전체 내용과 함께 <UI>공지 내리기</UI>·<UI>접어두기</UI> 버튼이 나옵니다.
      </>
    </Steps>
    <List>
      <>새 공지를 등록하면 이전 공지는 자동으로 교체됩니다. 공지된 메시지가 삭제되면 공지도 함께 내려갑니다.</>
      <>
        <UI>접어두기</UI>는 나에게만 적용됩니다. 접으면 오른쪽 위 작은 확성기 아이콘으로 줄어들고, 누르면 다시
        펼쳐집니다. 새 공지가 등록되면 자동으로 다시 나타납니다.
      </>
    </List>

    <Sub>이모지로 반응하기</Sub>
    <P>
      짧은 확인이나 공감은 답장 대신 반응으로 남기면 대화가 깔끔해집니다. 메시지 위에 마우스를 올린 뒤 웃는 얼굴
      버튼을 누르면 일곱 가지 중에서 고를 수 있습니다.
    </P>
    <P className="text-lg">✅ 👍 👎 ❤️ 😂 😮 👏</P>
    <List>
      <>선택한 이모지는 말풍선 아래에 개수와 함께 표시됩니다.</>
      <>내가 누른 반응에는 파란 테두리가 생깁니다. 한 번 더 누르면 취소됩니다.</>
      <>반응 배지에 마우스를 올리면 누가 눌렀는지 이름이 나옵니다.</>
    </List>

    <Sub>읽음 표시 (초록색 숫자)</Sub>
    <P>
      말풍선 옆의 초록색 숫자는 <b>아직 읽지 않은 사람 수</b>입니다. 카카오톡과 같은 방식으로, 모두가 읽으면
      숫자가 사라집니다. 그룹 대화방에서는 아직 몇 명이 못 봤는지 바로 알 수 있습니다.
    </P>
    <Callout tone="warn" title="창이 뒤에 있으면 읽음 처리되지 않습니다">
      <p>
        대화방을 열어두었더라도 다른 프로그램을 보고 있는 동안 도착한 메시지는 읽은 것으로 처리되지 않습니다.
        창을 다시 클릭해 앞으로 가져오는 순간 읽음으로 바뀝니다.
      </p>
      <p>
        PC와 노트북에 함께 로그인해 두었다면, <b>어느 한 곳에서 읽으면 모든 기기에서 배지가 사라집니다.</b>
      </p>
    </Callout>

    <Sub>지난 대화 보기</Sub>
    <List>
      <>
        대화방에 들어가면 최근 메시지 100개가 먼저 보입니다. 더 옛날 내용을 보려면 목록 맨 위의{' '}
        <UI>이전 메시지 불러오기</UI> 버튼을 누릅니다. 한 번에 100개씩 더 불러오며, 더 이상 없으면 버튼이
        사라집니다.
      </>
      <>불러온 뒤에도 읽고 있던 위치가 그대로 유지되므로 흐름을 놓치지 않습니다.</>
      <>
        위로 올라가 있으면 오른쪽 아래에 <UI>최근 채팅</UI> 버튼이 떠서, 누르면 맨 아래로 돌아갑니다.
      </>
    </List>

    <Sub>대화 내용 검색</Sub>
    <Steps>
      <>
        대화창 오른쪽 위 돋보기 버튼을 누르거나 <Kbd>Ctrl</Kbd> + <Kbd>F</Kbd> 를 누릅니다.
      </>
      <>검색어를 입력하면 일치하는 부분이 노란색으로 강조되고 해당 메시지로 이동합니다.</>
      <>
        <Kbd>Enter</Kbd> 로 다음 결과, <Kbd>Shift</Kbd> + <Kbd>Enter</Kbd> 로 이전 결과로 이동합니다. 위아래
        화살표 버튼도 같은 역할을 합니다.
      </>
      <>
        <Kbd>Esc</Kbd> 또는 <UI>×</UI> 로 검색을 닫습니다.
      </>
    </Steps>
    <Callout tone="danger" title="검색어 찾기는 화면에 불러온 메시지 안에서만 동작합니다">
      <p>
        예전 대화에서 검색어를 찾으려면 아래 <b>날짜로 이동</b>으로 그 시기로 옮긴 다음 검색하세요. 목록 맨
        위의 <UI>이전 메시지 불러오기</UI>로 더 불러온 뒤 검색해도 됩니다.
      </p>
      <p>삭제된 메시지는 검색되지 않으며, 대문자와 소문자는 구분하지 않습니다.</p>
    </Callout>

    <Sub>날짜로 이동하기</Sub>
    <Steps>
      <>
        검색창을 연 다음 오른쪽 <UI>달력</UI> 칸에서 날짜를 고릅니다. 검색어는 입력하지 않아도 됩니다.
      </>
      <>그 날짜의 첫 대화로 화면이 이동하고, 해당 메시지가 잠시 노란색으로 표시됩니다.</>
      <>
        그 시점 앞뒤로 <UI>이전 메시지 불러오기</UI>·<UI>다음 메시지 불러오기</UI>를 눌러 계속 읽을 수
        있습니다.
      </>
      <>
        오른쪽 아래 <UI>최근 대화로</UI> 버튼을 누르면 원래 최신 대화로 돌아옵니다.
      </>
    </Steps>
    <Callout tone="info" title="과거 대화를 보는 동안에는">
      <p>
        새로 도착한 메시지가 화면에 끼어들지 않습니다. 왼쪽 대화 목록의 안 읽음 개수로만 알려주고,{' '}
        <UI>최근 대화로</UI> 돌아왔을 때 비로소 읽음 처리됩니다.
      </p>
      <p>과거 대화를 보는 중에 메시지를 보내면 자동으로 최신 대화로 돌아간 뒤 전송됩니다.</p>
      <p>
        1:1·그룹 대화방에서는 <b>내가 참여하기 이전 날짜</b>로는 이동할 수 없습니다.
      </p>
    </Callout>

    <Sub>화면에 보이는 것들</Sub>
    <List>
      <>내가 보낸 메시지는 오른쪽 파란 말풍선, 상대 메시지는 왼쪽 흰 말풍선입니다.</>
      <>
        날짜가 바뀌면 <UI>오늘</UI>, <UI>어제</UI>, <UI>2026년 8월 3일 월요일</UI> 같은 구분선이 들어갑니다.
      </>
      <>관리자가 보낸 공지 메시지는 프로필 사진 자리에 &ldquo;관리자&rdquo; 표시가 붙습니다.</>
      <>누가 들어오고 나갔는지, 통화가 언제 끝났는지 같은 안내는 가운데 정렬된 회색 글씨로 표시됩니다.</>
      <>
        상대방이 글을 쓰고 있으면 화면 왼쪽 아래에 <UI>○○○님이 입력 중</UI> 표시가 잠시 나타납니다.
      </>
    </List>

    <Sub>말풍선 메뉴 (우클릭 · 길게 누르기)</Sub>
    <P>
      PC에서는 <b>메시지를 우클릭</b>하면, 휴대폰·태블릿에서는 <b>메시지를 0.5초 이상 길게 누르면</b> 메뉴가
      열립니다. 메뉴 위쪽에 반응 이모지 여섯 개가 있고, 아래에 답장 · 복사 · 전달 · 선택하여 전달 · 수정 ·
      공지로 등록 · 삭제가 있습니다. 복사·공지로 등록은 글자가 있는 메시지에서만, 수정·삭제는 내가 보낸
      메시지에서만 나타납니다.
    </P>
  </>
);
